import type { WbElement } from './whiteboard.api';

export const BOARD_W = 1280;
export const BOARD_H = 720;

/** Draws a whiteboard scene onto a 2D context. Used for live canvas + export. */
export function renderScene(ctx: CanvasRenderingContext2D, scene: WbElement[], background = '#ffffff'): void {
  ctx.save();
  ctx.fillStyle = background;
  ctx.fillRect(0, 0, BOARD_W, BOARD_H);

  for (const el of scene) {
    ctx.strokeStyle = el.color;
    ctx.fillStyle = el.color;
    ctx.lineWidth = 'width' in el ? el.width : 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';

    switch (el.type) {
      case 'path': {
        if (el.points.length < 2) break;
        ctx.beginPath();
        ctx.moveTo(el.points[0].x, el.points[0].y);
        for (const p of el.points.slice(1)) ctx.lineTo(p.x, p.y);
        ctx.stroke();
        break;
      }
      case 'rect':
        ctx.lineWidth = 2;
        ctx.strokeRect(el.x, el.y, el.w, el.h);
        break;
      case 'ellipse':
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.ellipse(el.x + el.w / 2, el.y + el.h / 2, Math.abs(el.w / 2), Math.abs(el.h / 2), 0, 0, Math.PI * 2);
        ctx.stroke();
        break;
      case 'text':
        ctx.font = `${el.size}px Inter, sans-serif`;
        ctx.fillText(el.text, el.x, el.y);
        break;
      case 'note': {
        ctx.fillStyle = el.color;
        ctx.fillRect(el.x, el.y, el.w, el.h);
        ctx.fillStyle = '#0f172a';
        ctx.font = '16px Inter, sans-serif';
        wrapText(ctx, el.text, el.x + 10, el.y + 26, el.w - 20, 20);
        break;
      }
    }
  }
  ctx.restore();
}

function wrapText(ctx: CanvasRenderingContext2D, text: string, x: number, y: number, maxW: number, lh: number): void {
  const words = text.split(' ');
  let line = '';
  let yy = y;
  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (ctx.measureText(test).width > maxW && line) {
      ctx.fillText(line, x, yy);
      line = w;
      yy += lh;
    } else {
      line = test;
    }
  }
  if (line) ctx.fillText(line, x, yy);
}
